export default [
  { key: 'ibisHotelsBudgetDE', value: 'ibisHotelsBudgetDE' },
  { key: 'ibisStylesBudgetDE', value: 'ibisStylesBudgetDE' },
  { key: 'ibisHotelsHotelsDE', value: 'ibisHotelsHotelsDE' },
  { key: 'ibisStylesStylesDE', value: 'ibisStylesStylesDE' },
  { key: 'ibisBudgetBudgetDE', value: 'ibisBudgetBudgetDE' }
]
